import { ColumnActionsMode } from '@fluentui/react';
import { ColumnData } from 'common/components/SearchBar';
import { commonColumnProps } from 'common/utils/columnUtilities';

const useColumns = () => {
  const columns: ColumnData[] = [
    {
      key: 'approverName',
      name: 'User',
      fieldName: 'approverName',
      minWidth: 200,
      maxWidth: 200,
      columnActionsMode: ColumnActionsMode.disabled,
      ...commonColumnProps,
    },
    {
      key: 'actionDate',
      name: 'Date',
      fieldName: 'actionDate',
      minWidth: 150,
      maxWidth: 150,
      columnActionsMode: ColumnActionsMode.disabled,
      ...commonColumnProps,
    },

    {
      key: 'comments',
      name: 'Comments',
      fieldName: 'comments',
      minWidth: 200,
      maxWidth: 200,
      columnActionsMode: ColumnActionsMode.disabled,
      ...commonColumnProps,
    },
    {
      key: 'statusType',
      name: 'Status',
      fieldName: 'statusType',
      minWidth: 120,
      maxWidth: 120,
      columnActionsMode: ColumnActionsMode.disabled,
      ...commonColumnProps,
    },
    {
      key: 'action',
      name: 'Action',
      fieldName: 'action',
      minWidth: 350,
      maxWidth: 350,
      columnActionsMode: ColumnActionsMode.disabled,
      ...commonColumnProps,
    },
  ];
  return { columns };
};
export { useColumns };
